<template>
  <div>
    <CRow>
      <CCol md="12">
        <CForm>

          <CCard>
            <CCardHeader class="p-1">
              <CRow>
                <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong >{{ $t('VisitorCategory') }}</strong>

                </CCol>
                <CCol col="4" style="text-align: end">


                  <CButton  class="mr-1 ml-1"  @click="insert_data()" size="sm"
                           color="secondary">
                    {{ $t('buttons.submit') }}
                  </CButton>

                </CCol>
              </CRow>
            </CCardHeader>

            <CCardBody>


              <CRow>


                <CCol col="3">


                  <CSelect
                          :label="$t('productGroup')"
                          horizontal
                          :value.sync="selected_category"
                          :options="category_items"
                  />
                </CCol>


              </CRow>


              <CDataTable
                  :items="product_items"
                  :fields="product_fields"

                  :items-per-page="200"
                  hover
                  sorter
                  pagination
              >
                <template #row="{item,index}">

                  <td style="text-align: center">

                  <p >{{ index + 1 }}</p>

                  </td>

                </template>
                <template #catRelId="{item}">

                  <td>
                    <p v-if="category_items.filter(x=>x.value==item.catRelId)[0]!=null">{{ category_items.filter(x=>x.value==item.catRelId)[0].label }}</p>

                  </td>

                </template>


                <template #qty="{item}">

                  <td>
                    <p >{{ item.count }}</p>

                  </td>

                </template>

                <template #summary="{item}">

                  <td>
                    <p >{{ item.summary }}</p>

                  </td>

                </template>


                <template #operation="{item}">
                  <td>
<!--                    <CButton-->
<!--                        color="primary"-->
<!--                        variant="outline"-->
<!--                        square-->
<!--                        size="sm"-->
<!--                        @click="edit_item(item)"-->
<!--                    >{{ $t('buttons.edit') }}-->
<!--                    </CButton>-->
                    <CButton
                        square
                        size="sm"
                        @click="delete_item_dialog(item)"
                    ><CIcon name="cilTrash" class="text-danger" size="sm" />
                    </CButton>
                  </td>
                </template>


              </CDataTable>


            </CCardBody>

          </CCard>
        </CForm>

      </CCol>
    </CRow>
    <CRow>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Vue from "vue";

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

var product_items = [];


export default {
  name: 'VisitorCategory',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      VUE_APP_Currency: localStorage.getItem('currency'),

      date: '',
      product_items: product_items.map((item, row_id) => {
        return {...item, row_id}
      }),
      product_fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'catRelId', label: this.$t('tables.name'), _style: 'width:15%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;'},

      ],
      price_target:'',
      selected_target_type:0,
        category_items:[],
        selected_category:0,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });

  }, watch: {


  },
  methods: {

      get_categories() {
          var self = this;

        this.$apis.get_cats().then(result => {
          self.category_items = result
          self.get_lists()

        })


      },

    insert_data() {

      let self = this;
      const formData = new FormData();
      let url;

        url = "AddPersonCategory";



        formData.append('PersonId', this.$route.params.user_id);
        formData.append('CatRelId', this.selected_category);
        axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
            var content_data = res.data;

            // items = content_cats.orders;
        if (content_data.statusCode == 0) {

                self.get_lists()

        } else {
          // this.$router.push({path:'/dashboard/products/list'})

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists() {

      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "GetPersonCategories";

          formData.append('Id', this.$route.params.user_id);

      axios.post(url, formData, {}).then((res) => {
if(res.data.statusCode==0){
    self.product_items = res.data.data
}

      })
          .catch(function (error) {

            console.log(error);
          });


    },
      delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {

      let self = this;
      const formData = new FormData()
      let url;
      url = "DelPersonCategory";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

          this.$root.modal_component.show_api_response_modals(res);

          self.status_form = 0;

           self.get_lists();


      })
          .catch(function (error) {
              console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person = content_data.data.partyName;
          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.PlaceId;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
